import { Cell, CellLink, CellList } from "@/directory/DirectoryTable/Cells";
import getClassroomName from "@/directory/utils/getClassroomName";
import getNameOfUser from "@/directory/utils/getNameOfUser";

const NAME = {
  accessor: "name",
  Header: "Class name",
  Cell: (cell) => <Cell cell={cell} />,
};

const NAME_WITH_LINK = {
  accessor: "name",
  Header: "Class name",
  Cell: (cell) => (
    <CellLink
      href={`/account/classes/${cell.cell.row.original.id}/`}
      value={getClassroomName(cell.cell.row.original)}
    />
  ),
};

const TEACHERS = {
  accessor: "teachers",
  Header: "Teachers",
  disableSortBy: true,
  Cell: (cell) => (
    <CellList
      values={cell.value.map(({ user }) => getNameOfUser(user))}
      label="teachers"
    />
  ),
};

const CLASS_CODE = {
  accessor: "class_code",
  Header: "Code",
  disableSortBy: true,
  Cell: (cell) => <Cell cell={cell} />,
};

const SCHOOL = {
  accessor: "school",
  Header: "School",
  Cell: (cell) => <Cell cell={{ ...cell, value: cell.value?.name }} />,
};

const SUBJECTS = {
  accessor: "subjects",
  Header: "Subjects",
  disableSortBy: true,
  Cell: (cell) => (
    <CellList
      values={cell.value.map((subject) => subject.title)}
      label="subjects"
    />
  ),
};

const GRADE = {
  accessor: "grade",
  Header: "Grade",
  Cell: (cell) => (
    <Cell cell={{ ...cell, value: cell.value === 0 ? "KG" : cell.value }} />
  ),
};

const STUDENTS = {
  accessor: "students",
  Header: "Students",
  disableSortBy: true,
  Cell: (cell) => (
    <CellList
      values={cell.value.map(({ user }) => getNameOfUser(user))}
      label="students"
    />
  ),
};

const STATUS = {
  accessor: "status",
  Header: "Status",
  Cell: (cell) => (
    <Cell
      cell={{
        ...cell,
        value: cell.cell.row.original.date_archived ? "Archived" : "Active",
      }}
    />
  ),
};

const DATE_SOURCE = {
  accessor: "provider",
  Header: "Data source",
  Cell: (cell) => <Cell cell={{ ...cell, value: cell.value.name }} />,
};

export const FILTER_UI_PROPS = {
  id: "classroomsFilters",
  searchFieldLabel: "Search for classes",
  searchFieldPlaceholder: "Search all classes...",
  title: "Filter classes",
  triggerButtonLabel: "Filter classes",
};

export const getColumns = (role) => {
  switch (role) {
    case "student":
      return [NAME, TEACHERS, CLASS_CODE, SCHOOL];
    case "parent":
      return [NAME_WITH_LINK, STUDENTS, STATUS, CLASS_CODE];
    default:
      return [
        NAME_WITH_LINK,
        SUBJECTS,
        GRADE,
        SCHOOL,
        STUDENTS,
        STATUS,
        DATE_SOURCE,
        CLASS_CODE,
      ];
  }
};
